import { render } from "./operating-area.vue?vue&type=template&id=c8649efe"
import script from "./operating-area.vue?vue&type=script&lang=js"
export * from "./operating-area.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__